import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Circle, ArrowRight, Rocket } from "lucide-react";

const STEPS = [
  { key: "profile_complete", label: "Complete your profile", to: "/profile", cta: "Complete" },
  { key: "has_base_cv", label: "Upload your base CV", to: "/cvs", cta: "Upload" },
  { key: "has_tailored_cv", label: "Tailor your first CV to a job", to: "/tailor?first=1", cta: "Tailor" },
  { key: "has_application", label: "Track your first application", to: "/tracker", cta: "Track" },
];

export function OnboardingChecklist() {
  const [state, setState] = useState(null);
  const [dismissed, setDismissed] = useState(localStorage.getItem("onboarding_dismissed") === "1");

  useEffect(() => {
    api.get("/onboarding").then(({ data }) => setState(data)).catch(() => {});
  }, []);

  if (!state || dismissed) return null;
  const done = STEPS.filter((s) => state[s.key]).length;
  if (done === STEPS.length) return null;

  const nextStep = STEPS.find((s) => !state[s.key]);

  return (
    <div className="bg-primary text-primary-foreground rounded-xl p-5 sm:p-6" data-testid="onboarding-checklist">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Rocket className="h-5 w-5" strokeWidth={1.75} />
          <div>
            <p className="font-heading font-bold text-base">Get started with Jobsmith</p>
            <p className="text-xs text-primary-foreground/70">{done} of {STEPS.length} done — finish setup to land your next interview.</p>
          </div>
        </div>
        <button onClick={() => { localStorage.setItem("onboarding_dismissed", "1"); setDismissed(true); }} className="text-xs text-primary-foreground/60 hover:text-primary-foreground transition-colors" data-testid="onboarding-dismiss">Hide</button>
      </div>
      <ul className="space-y-1.5">
        {STEPS.map((s) => {
          const complete = !!state[s.key];
          const isNext = !complete && s.key === nextStep?.key;
          return (
            <li key={s.key} className={`flex items-center justify-between gap-3 rounded-lg px-3 py-2 ${isNext ? "bg-primary-foreground/10" : ""}`} data-testid={`onboarding-step-${s.key}`}>
              <span className="flex items-center gap-2.5 text-sm">
                {complete
                  ? <CheckCircle2 className="h-4 w-4 text-green-400 shrink-0" strokeWidth={2} />
                  : <Circle className="h-4 w-4 text-primary-foreground/40 shrink-0" strokeWidth={2} />}
                <span className={complete ? "line-through text-primary-foreground/50" : ""}>{s.label}</span>
              </span>
              {!complete && (
                <Link to={s.to} className="shrink-0" data-testid={`onboarding-cta-${s.key}`}>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold bg-primary-foreground text-primary rounded-full px-3 py-1 hover:opacity-90 transition-opacity">
                    {s.cta} <ArrowRight className="h-3 w-3" strokeWidth={2} />
                  </span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
